module.exports = __webpack_public_path__ + "img/compare-0.72979cfe.jpg";